/* Club de escucha: campo de ondas en canvas (34fps, escala 0,42), texto y
   boton que leen el MISMO campo (no imitan la onda), isotipo como pegatina
   de vidrio (solo los cantos, revelados por la onda). Nace apagado: reloj
   clavado en P*2 y tintas lavadas; la corriente del cable lo enciende en un
   cuadro. Ver CLAUDE.md, "Club de escucha". */
const { mount, reduced, yaVisto, marcarVisto } = window.EQ;

mount('[data-eq-club]', (sec) => {
  const D = sec.dataset;
  const num = (k, def) => { const v = D[k]; return v === undefined || v === '' ? def : Number(v); };
  const bool = (k, def) => { const v = D[k]; return v === undefined ? def : v === 'true'; };
  const q = (s) => sec.querySelector(s);
  const field = q('[data-eq-field]'), tint = q('[data-eq-tint]'), markC = q('[data-eq-mark]');
  const stage = q('[data-eq-stage]'), logoWrap = q('[data-eq-logo-wrap]');
  const cta = q('[data-eq-cta]'), ctaDot = q('[data-eq-cta-dot]'), entry = q('[data-eq-entry]');
  const lento = reduced();
  const S = {
    enc: false, visible: false, raf: 0, t0: null, last: 0, armado: false, terceroCorriente: null,
    hover: false, mfl: [], letters: null, letterEls: [], splitting: false, mo: null, moT: 0, regT: [],
    guard: 0, demora: 0, io: null
  };
  let ctx, ctxA, ctxB, ctxM, buf, W, H, cw, ch, ex, ey, logoR, exC, eyC, logoC, maxR, mirrors, ctaD, ctaUx, ctaUy, ctaFl, ctaU = 0, ctaS = 0, fT = 0, cT = 0;
  let emitters, emitOn, emitOff, P, LIFE, GAIN, SUB, ECHO, LOGO, LFIJO, SCALE, STEP, AMP, VAR, JER, ASIM;

  const rgb = (hex) => {
    const h = String(hex).replace('#', '');
    const n = h.length === 3 ? h.split('').map((x) => x + x).join('') : h;
    return [parseInt(n.slice(0, 2), 16), parseInt(n.slice(2, 4), 16), parseInt(n.slice(4, 6), 16)];
  };

  // Un emisor y tres colores desfasados. Dos juegos de tintas (apagado/encendido)
  // armados una sola vez: encender es cambiar el puntero.
  const build = () => {
    const tercero = S.terceroCorriente || D.colorTercero || '#8544d5';
    const soft = (c, k) => [c[0] + (255 - c[0]) * k, c[1] + (255 - c[1]) * k, c[2] + (255 - c[2]) * k];
    const PAPER = [245, 243, 238];
    const SAT = Math.max(0, Math.min(1.3, num('saturacion', 100) / 100));
    const SATOFF = Math.min(SAT, Math.max(0, num('satApagado', 30)) / 100);
    // 60/30/10: naranja manda, el ambar acompana a medio periodo con menos peso
    // y el violeta aparece una de cada tres ondas, en el hueco entre las otras dos.
    JER = true;
    const J = JER;
    const juego = (Sx) => {
      const flat = (c) => c.map((v, i) => Math.max(0, Math.min(255, PAPER[i] + (v - PAPER[i]) * Sx)));
      return [
        { c: flat(rgb(D.colorNaranja || '#f59f52')), phase: 0, w: 1, every: 1 },
        { c: flat(rgb('#f3c26b')), phase: J ? 1 / 2 : 1 / 3, w: J ? 0.6 : 1, every: 1 },
        { c: flat(rgb(tercero)), phase: J ? 1 / 4 : 2 / 3, w: 1, every: J ? 3 : 1 }
      ].map((e) => Object.assign(e, { tint: soft(e.c, 0.08) }));
    };
    emitOn = juego(SAT); emitOff = juego(SATOFF);
    emitters = S.enc ? emitOn : emitOff;
    P = Math.max(1.2, num('periodo', 4));
    LIFE = P * 3;
    GAIN = Math.max(0.2, num('intensidad', 2));
    SUB = bool('subtractivo', false);
    ECHO = bool('rebote', true);
    LOGO = Math.max(0, Math.min(1, num('logoOpacidad', 25) / 100));
    LFIJO = bool('logoFijo', false);
    // frente asimetrico: canto delantero nitido y cola larga hacia el centro
    ASIM = true;
    SCALE = ASIM ? 0.5 : 0.42;
    STEP = 1000 / 34;
    AMP = num('relieve', 1.5) * 3.4;
    VAR = num('variacion', 0.4);
  };

  const sizeField = () => {
    if (!field || !tint) return;
    const r = sec.getBoundingClientRect();
    W = Math.max(320, Math.round(r.width * SCALE));
    H = Math.max(200, Math.round(r.height * SCALE));
    [field, tint].forEach((c) => { c.width = W; c.height = H; });
    ctxA = field.getContext('2d'); ctxB = tint.getContext('2d');
    if (!buf) buf = document.createElement('canvas');
    buf.width = W; buf.height = H;
    ctx = buf.getContext('2d');
    ctx.__cw = W; ctx.__ch = H; ctxB.__cw = W; ctxB.__ch = H;
    if (markC) {
      const dpr = Math.min(2, window.devicePixelRatio || 1);
      cw = Math.round(r.width); ch = Math.round(r.height);
      markC.width = Math.round(cw * dpr); markC.height = Math.round(ch * dpr);
      ctxM = markC.getContext('2d');
      ctxM.setTransform(dpr, 0, 0, dpr, 0, 0);
      ctxM.__cw = cw; ctxM.__ch = ch;
    }
  };

  const measure = () => {
    const r = sec.getBoundingClientRect();
    let ex0 = r.width / 2, ey0 = r.height * 0.66, logo = 104;
    if (logoWrap) {
      const g = logoWrap.getBoundingClientRect();
      logo = Math.max(64, Math.min(118, g.height / 2 - 6));
      // el isotipo es excentrico: el emisor se corre lo que el SVG corre el circulo grande
      const Lx = logo / 60;
      ex0 = g.left - r.left + g.width / 2 + 10.4 * Lx;
      ey0 = g.top - r.top + g.height / 2 - 6 * Lx;
    }
    ex = ex0 * SCALE; ey = ey0 * SCALE; logoR = logo * SCALE;
    exC = ex0; eyC = ey0; logoC = logo;
    const cx = Math.max(ex, W - ex), cy = Math.max(ey, H - ey);
    maxR = Math.hypot(cx, cy) * 1.04;
    mirrors = [[-ex, ey], [2 * W - ex, ey], [ex, -ey], [ex, 2 * H - ey]];
    measureLetters();
    if (cta) {
      cta.style.transform = 'none';
      cta.style.transformOrigin = '50% 58%';
      if (cta.parentNode && cta.parentNode.style) cta.parentNode.style.perspective = '760px';
      const g = cta.getBoundingClientRect();
      const dx = (g.left - r.left + g.width / 2) - exC;
      const dy = (g.top - r.top + g.height / 2) - eyC;
      const d = Math.hypot(dx, dy) || 1;
      ctaD = d; ctaUx = dx / d; ctaUy = dy / d;
    }
  };

  // split por caracter hecho en runtime y rehecho cuando cambia el copy
  const splitType = () => {
    if (!stage) return;
    const targets = Array.from(stage.querySelectorAll('[data-eq-flow]'));
    if (!targets.length) return;
    S.splitting = true;
    if (S.mo) S.mo.disconnect();
    S.letterEls = [];
    targets.forEach((el) => {
      el.style.perspective = '760px';
      el.style.transformStyle = 'preserve-3d';
      const marked = el.firstElementChild && el.firstElementChild.hasAttribute('data-eq-ch');
      const txt = marked ? (el.getAttribute('data-eq-text') || el.textContent) : el.textContent;
      el.setAttribute('data-eq-text', txt);
      const frag = document.createDocumentFragment();
      // cada palabra va en un envoltorio nowrap: si no, el renglon se puede
      // partir entre letras. El envoltorio lleva data-eq-ch (la deteccion de
      // "ya esta partido" mira el firstElementChild) pero NO se anima.
      let word = null;
      for (const chr of txt) {
        if (chr === ' ' || chr === '\n' || chr === '\t') { word = null; frag.appendChild(document.createTextNode(' ')); continue; }
        if (!word) {
          word = document.createElement('span');
          word.setAttribute('data-eq-ch', '');
          word.setAttribute('data-eq-word', '');
          word.style.whiteSpace = 'nowrap';
          word.style.transformStyle = 'preserve-3d';
          frag.appendChild(word);
        }
        const s = document.createElement('span');
        s.setAttribute('data-eq-ch', '');
        s.style.display = 'inline-block';
        s.style.willChange = 'transform';
        s.style.transformOrigin = '50% 58%';
        s.textContent = chr;
        word.appendChild(s);
        S.letterEls.push(s);
      }
      el.textContent = '';
      el.appendChild(frag);
    });
    if (!S.mo) {
      S.mo = new MutationObserver(() => {
        if (S.splitting) return;
        clearTimeout(S.moT);
        S.moT = setTimeout(() => { splitType(); measure(); }, 60);
      });
    }
    targets.forEach((el) => S.mo.observe(el, { childList: true, characterData: true, subtree: true }));
    setTimeout(() => { S.splitting = false; }, 0);
  };
  const measureLetters = () => {
    if (!S.letterEls.length) { S.letters = null; return; }
    const r = sec.getBoundingClientRect();
    S.letters = S.letterEls.map((el) => {
      el.style.transform = 'none';
      const b = el.getBoundingClientRect();
      const dx = (b.left - r.left + b.width / 2) - exC;
      const dy = (b.top - r.top + b.height / 2) - eyC;
      const d = Math.hypot(dx, dy) || 1;
      const fs = parseFloat(getComputedStyle(el).fontSize) || 48;
      const rel = Math.min(1, fs / 48);
      return { el, d, ux: dx / d, uy: dy / d, k: Math.max(0.12, Math.pow(rel, 1.8)), u: 0, s: 0, on: false, fl: undefined };
    });
  };

  const hash = (a, b) => { const x = Math.sin(a * 127.1 + b * 311.7) * 43758.5453; return x - Math.floor(x); };
  const emission = (i, n, t) => {
    const ph = emitters[i].phase;
    const base = (t + ph * P) % P;
    const idx = Math.floor((t + ph * P) / P) - n;
    // el acento emite una de cada `every`: las demas quedan fuera de vida y todo
    // lo que recorre emisiones las descarta sola (age > LIFE)
    const em = emitters[i];
    if (em.every > 1 && ((idx % em.every) + em.every) % em.every !== 0) return { age: Infinity, av: 0 };
    const j = hash(idx, i), j2 = hash(idx, i + 7);
    return { age: Math.max(0, base + n * P + (j - 0.5) * 0.07 * P * VAR), av: (1 + (j2 - 0.5) * 0.9 * VAR) * (em.w || 1) };
  };
  const width = (r) => 20 * SCALE + r * 0.135;
  const drift = (r, r0) => { const d = Math.max(0, r - (r0 || 0)); return [-0.168 * d, 0.097 * d]; };

  const ring = (c2, op, cx, cy, r, w, c, a, mul) => {
    if (a <= 0.002 || r <= 0) return;
    const col = mul === 1 ? c : [c[0] * mul, c[1] * mul, c[2] * mul];
    const rgba = (k) => 'rgba(' + Math.round(col[0]) + ',' + Math.round(col[1]) + ',' + Math.round(col[2]) + ',' + k.toFixed(4) + ')';
    // asimetrico: el canto de afuera corta casi a pico y la cola se estira hacia
    // adentro; simetrico es la campana de antes
    let g, s;
    if (ASIM) {
      const r0 = Math.max(0, r - w * 2.4), r1 = r + w * 0.28, L = r1 - r0;
      const at = (x) => Math.max(0, Math.min(1, (x - r0) / L));
      g = c2.createRadialGradient(cx, cy, r0, cx, cy, r1);
      g.addColorStop(0, rgba(0));
      g.addColorStop(at(r - w * 1.5), rgba(a * 0.14));
      g.addColorStop(at(r - w * 0.7), rgba(a * 0.46));
      g.addColorStop(at(r - w * 0.12), rgba(a * 0.92));
      g.addColorStop(at(r), rgba(a));
      g.addColorStop(1, rgba(0));
      s = r1;
    } else {
      g = c2.createRadialGradient(cx, cy, Math.max(0, r - w), cx, cy, r + w);
      g.addColorStop(0, rgba(0)); g.addColorStop(0.3, rgba(a * 0.36));
      g.addColorStop(0.5, rgba(a)); g.addColorStop(0.7, rgba(a * 0.36));
      g.addColorStop(1, rgba(0));
      s = r + w;
    }
    c2.globalCompositeOperation = op;
    c2.fillStyle = g;
    const CW = c2.__cw || W, CH = c2.__ch || H;
    const x0 = Math.max(0, cx - s), y0 = Math.max(0, cy - s), x1 = Math.min(CW, cx + s), y1 = Math.min(CH, cy + s);
    if (x1 <= x0 || y1 <= y0) return;
    c2.fillRect(x0, y0, x1 - x0, y1 - y0);
  };
  const pass = (c2, t, v, r0, cx, cy, gain, count) => {
    const R = maxR;
    for (let i = 0; i < emitters.length; i++) {
      const em = emitters[i];
      for (let n = 0; n < count; n++) {
        const e = emission(i, n, t);
        if (e.age > LIFE) continue;
        const r = r0 + e.age * v;
        const k = (r - r0) / (R - r0);
        const amp = Math.pow(1 - k, gain < 1 ? 0.85 : 0.5) * Math.min(1, e.age / 0.45) * GAIN * gain * e.av;
        if (amp <= 0.004) continue;
        const w = width(r);
        const d = drift(r, r0);
        const addMix = 0.66 + 0.34 * Math.max(0, 1 - r / (R * 0.62));
        ring(c2, 'lighter', cx + d[0], cy + d[1], r, w, em.c, 0.22 * amp * addMix, 1);
        if (SUB && gain === 1) {
          const sub = Math.min(1, Math.max(0, (r - R * 0.34) / (R * 0.66)));
          if (sub > 0.001) ring(c2, 'multiply', cx + d[0], cy + d[1], r, w * 1.3, em.c, 0.4 * amp * sub, 0.34);
        }
      }
    }
  };

  // envolvente del campo en un punto: altura (e) y pendiente (s), frente dominante (i)
  const env = (t, dist, wk, px, py) => {
    const R = maxR / SCALE, r0 = (logoR * 0.25) / SCALE;
    const v = (R - r0) / LIFE;
    const K = wk || 1.15;
    let sb = 0, sb2 = 0, sbs = 0, best = 0, bi = 0;
    for (let i = 0; i < emitters.length; i++) {
      for (let n = 0; n < 3; n++) {
        const e = emission(i, n, t);
        if (e.age > LIFE) continue;
        const r = r0 + e.age * v;
        const k = (r - r0) / (R - r0);
        const amp = Math.pow(1 - k, 0.55) * Math.min(1, e.age / 0.45) * e.av;
        if (amp <= 0.01) continue;
        const w = (20 + r * 0.135) * K;
        let dist2 = dist;
        if (px !== undefined) { const dr = drift(r, r0); dist2 = Math.hypot(px - (exC + dr[0]), py - (eyC + dr[1])); }
        const dd = (dist2 - r) / w;
        // misma forma que el campo: llega de golpe y se retira despacio
        const lo = ASIM ? -4.2 : -2.6, hi = ASIM ? 1.1 : 2.6;
        if (dd > hi || dd < lo) continue;
        const kk = ASIM ? (dd > 0 ? 5.2 : 0.42) : 1.15;
        const bell = Math.exp(-dd * dd * kk) * amp;
        sb += bell; sb2 += bell * bell; sbs += dd * 2.5 * bell * bell;
        if (bell > best) { best = bell; bi = i; }
      }
    }
    const peak = sb > 1e-5 ? sb2 / sb : 0;
    return { e: Math.min(1, peak / 1.15), s: sb2 > 1e-5 ? sbs / sb2 : 0, i: bi };
  };

  const mark = (c2, t) => {
    const Lx = logoC / 60;
    const br = 1 + 0.005 * Math.sin((t / P) * Math.PI * 2);
    const s = Lx * br, TAU = Math.PI * 2;
    const ax = exC - 10.4 * s, ay = eyC + 6 * s, bx = exC - 5.2 * s, by = eyC + 3 * s;
    const circles = [[bx, by, 31.75 * s, 1], [bx, by, 40.25 * s, 0.42], [ax, ay, 55 * s, 0.86], [ax, ay, 65 * s, 0.36], [exC, eyC, 15 * s, 0.7]];
    c2.save();
    c2.lineWidth = 1;
    if (LFIJO) {
      c2.strokeStyle = 'rgba(245,243,238,' + (0.05 * LOGO).toFixed(3) + ')';
      circles.forEach((qq) => { c2.beginPath(); c2.arc(qq[0], qq[1], qq[2], 0, TAU); c2.stroke(); });
    }
    if (c2.createConicGradient) {
      c2.globalCompositeOperation = 'lighter';
      const N = 36;
      for (let c = 0; c < circles.length; c++) {
        const qq = circles[c];
        const g = c2.createConicGradient(0, qq[0], qq[1]);
        for (let k = 0; k <= N; k++) {
          const a = ((k % N) / N) * TAU;
          const f = env(t, 0, 1, qq[0] + Math.cos(a) * qq[2], qq[1] + Math.sin(a) * qq[2]);
          const ix = c * (N + 1) + (k % N);
          const raw = Math.min(1, f.e);
          if (S.mfl[ix] === undefined) S.mfl[ix] = raw;
          S.mfl[ix] += (raw - S.mfl[ix]) * (raw < S.mfl[ix] ? 0.12 : 0.0016);
          const hp = Math.max(0, Math.min(1, (raw - S.mfl[ix]) / Math.max(0.14, 1 - S.mfl[ix]) * 2.1));
          const al = hp * Math.sqrt(LOGO) * 0.26 * qq[3];
          const c0 = emitters[f.i].c;
          const col = [c0[0] + (255 - c0[0]) * 0.14, c0[1] + (255 - c0[1]) * 0.14, c0[2] + (255 - c0[2]) * 0.14];
          g.addColorStop(k / N, 'rgba(' + (col[0] | 0) + ',' + (col[1] | 0) + ',' + (col[2] | 0) + ',' + al.toFixed(4) + ')');
        }
        c2.strokeStyle = g; c2.lineWidth = 1;
        c2.beginPath(); c2.arc(qq[0], qq[1], qq[2], 0, TAU); c2.stroke();
      }
    }
    c2.restore();
    c2.globalCompositeOperation = 'source-over';
  };

  const smooth = (now, tau) => {
    const dt = Math.min(0.12, (now - (fT || now)) / 1000);
    fT = now;
    return 1 - Math.exp(-dt / (tau || 0.07));
  };
  const flow = (t, now) => {
    if (!S.letters || !S.letters.length) return;
    const a = smooth(now, 0.075);
    const K = AMP / 3.4;
    const live = K > 0.001;
    for (let Li = 0; Li < S.letters.length; Li++) {
      const lt = S.letters[Li];
      let e = 0, s = 0;
      if (live) {
        const f = env(t, lt.d, 1.55);
        const raw = Math.min(1, f.e);
        if (lt.fl === undefined) lt.fl = raw;
        lt.fl += (raw - lt.fl) * (raw < lt.fl ? 0.10 : 0.0016);
        const hp = Math.max(0, Math.min(1, (raw - lt.fl) / Math.max(0.14, 1 - lt.fl) * 2.1));
        e = hp * hp * (3 - 2 * hp);
        s = Math.max(-1, Math.min(1, f.s)) * Math.min(1, hp * 2.4);
      }
      lt.u += (e - lt.u) * a;
      lt.s += (s - lt.s) * a;
      if (lt.u < 0.003 && Math.abs(lt.s) < 0.003) { if (lt.on) { lt.el.style.transform = 'none'; lt.on = false; } continue; }
      lt.on = true;
      const Ke = K * lt.k;
      lt.el.style.transform = 'translate3d(0,' + (-1.1 * lt.u * Ke).toFixed(2) + 'px,' + (13 * lt.u * Ke).toFixed(2) + 'px)' +
        ' rotate3d(' + (-lt.uy).toFixed(3) + ',' + lt.ux.toFixed(3) + ',0,' + (13.5 * lt.s * Ke).toFixed(2) + 'deg)';
    }
  };
  const ctaField = (t, now) => {
    if (!cta || !ctaD) return;
    const a = 1 - Math.exp(-Math.min(0.12, (now - (cT || now)) / 1000) / 0.075);
    cT = now;
    const K = Math.max(0.35, AMP / 3.4);
    const f = env(t, ctaD, 1.55);
    const raw = Math.min(1, f.e);
    if (ctaFl === undefined) ctaFl = raw;
    ctaFl += (raw - ctaFl) * (raw < ctaFl ? 0.10 : 0.0016);
    const hp = Math.max(0, Math.min(1, (raw - ctaFl) / Math.max(0.14, 1 - ctaFl) * 2.1));
    const ge = hp * hp * (3 - 2 * hp);
    ctaU += (ge - ctaU) * a;
    ctaS += (Math.max(-1, Math.min(1, f.s)) * Math.min(1, hp * 2.4) - ctaS) * a;
    const u = ctaU, s = ctaS;
    cta.style.transform = u < 0.003 && Math.abs(s) < 0.003 ? 'none' :
      'translate3d(0,' + (-0.7 * u * K).toFixed(2) + 'px,' + (9 * u * K).toFixed(2) + 'px) rotate3d(' + (-(ctaUy || 1)).toFixed(3) + ',' + (ctaUx || 0).toFixed(3) + ',0,' + (5 * s * K).toFixed(2) + 'deg)';
    const c = emitters[f.i].c;
    const rgba = (k) => 'rgba(' + c[0] + ',' + c[1] + ',' + c[2] + ',' + k.toFixed(3) + ')';
    cta.style.boxShadow = u < 0.02 ? 'none' : '0 0 0 ' + (0.5 + 2.2 * u).toFixed(2) + 'px ' + rgba(0.85 * u) + ', 0 0 ' + (26 * u).toFixed(0) + 'px ' + rgba(0.3 * u);
    if (!S.hover && ctaDot) ctaDot.style.background = u < 0.05 ? '#1f1e1f' :
      'rgb(' + Math.round(31 + (c[0] - 31) * u * 0.85) + ',' + Math.round(30 + (c[1] - 30) * u * 0.85) + ',' + Math.round(31 + (c[2] - 31) * u * 0.85) + ')';
  };

  const frame = (now, force) => {
    if (!ctx || !maxR) return;
    if (lento && !force) return;
    emitters = S.enc ? (emitOn || emitters) : (emitOff || emitters);
    // apagado = el mismo campo detenido en P*2, no un campo vacio
    const t = S.enc ? ((now - (S.t0 = S.t0 || now)) / 1000) + P * 2 : P * 2;
    flow(t, now);
    ctaField(t, now);
    if (!force && S.last && now - S.last < STEP) return;
    S.last = now;
    const R = maxR, r0 = logoR * 0.25;
    const v = (R - r0) / LIFE;
    ctx.globalCompositeOperation = 'source-over';
    ctx.fillStyle = '#191819';
    ctx.fillRect(0, 0, W, H);
    // con jerarquia el fondo queda en negro puro: la cama gris velaba las tintas
    if (!JER) {
      const bed = ctx.createRadialGradient(ex, ey, 0, ex, ey, R);
      bed.addColorStop(0, 'rgba(152,148,142,0.20)'); bed.addColorStop(0.42, 'rgba(124,124,128,0.12)'); bed.addColorStop(0.8, 'rgba(108,110,120,0.06)'); bed.addColorStop(1, 'rgba(94,96,108,0.02)');
      ctx.fillStyle = bed; ctx.fillRect(0, 0, W, H);
    }
    if (ECHO) for (let m = 0; m < mirrors.length; m++) pass(ctx, t, v, r0, mirrors[m][0], mirrors[m][1], 0.62, 3);
    pass(ctx, t, v, r0, ex, ey, 1, 3);
    if (ctxM) { ctxM.clearRect(0, 0, cw, ch); if (LOGO > 0.001) mark(ctxM, t); }
    ctx.globalCompositeOperation = 'source-over';
    if (ctxA) { ctxA.clearRect(0, 0, W, H); ctxA.drawImage(buf, 0, 0); }
    if (ctxB) {
      const b = ctxB;
      b.globalCompositeOperation = 'source-over';
      b.fillStyle = '#ffffff'; b.fillRect(0, 0, W, H);
      for (let i = 0; i < emitters.length; i++) {
        const em = emitters[i];
        for (let n = 0; n < 3; n++) {
          const e = emission(i, n, t);
          if (e.age > LIFE) continue;
          const r = r0 + e.age * v;
          const flat = Math.min(1, e.age / 0.45) * (1 - Math.pow((r - r0) / (R - r0), 4)) * (0.62 + 0.38 * e.av);
          const d = drift(r, r0);
          ring(b, 'multiply', ex + d[0], ey + d[1], r, width(r) * 1.05, em.tint, 0.96 * flat, 1);
        }
      }
      b.globalCompositeOperation = 'source-over';
      b.fillStyle = 'rgba(255,255,255,0.12)'; b.fillRect(0, 0, W, H);
    }
  };

  const pump = () => {
    if (lento) { frame(performance.now(), true); return; }
    if (!S.enc) {
      if (S.raf) { cancelAnimationFrame(S.raf); S.raf = 0; }
      if (S.visible) { frame(performance.now(), true); armar(); }
      return;
    }
    if (S.visible && !S.raf) {
      const loop = (t) => { S.raf = requestAnimationFrame(loop); frame(t); };
      S.raf = requestAnimationFrame(loop);
    } else if (!S.visible && S.raf) { cancelAnimationFrame(S.raf); S.raf = 0; }
  };

  // fase 2: si en la pagina no hay cable, se enciende al entrar a la vista;
  // con cable espera, mas una red de 9s para que nunca quede muerto
  const armar = () => {
    if (S.armado) return;
    S.armado = true;
    const cable = document.querySelector('[data-eq-cable-body], [data-eq-boletin]');
    if (bool('esperaCorriente', true) === false || !cable) { encender(); return; }
    S.guard = setTimeout(() => encender(), 9000);
  };
  const contacto = (color) => {
    if (!entry || lento || !entry.animate) return;
    if (color) {
      const c = rgb(color);
      const a = (k) => 'rgba(' + c.join(',') + ',' + k + ')';
      entry.style.background = 'radial-gradient(circle,#ffffff 0%,' + a(0.85) + ' 22%,' + a(0.55) + ' 46%,' + a(0) + ' 70%)';
    }
    entry.animate([
      { opacity: 0, transform: 'translate(50%,-50%) scale(0.45)', offset: 0 },
      { opacity: 1, transform: 'translate(50%,-50%) scale(1)', offset: 0.04 },
      { opacity: 0, transform: 'translate(50%,-50%) scale(1.5)', offset: 1 }
    ], { duration: 270, easing: 'cubic-bezier(.2,0,.4,1)', fill: 'none' });
  };
  const prender = () => {
    if (S.enc) return;
    clearTimeout(S.guard);
    marcarVisto('club');
    S.enc = true; S.t0 = null;
    emitters = emitOn || emitters;
    pump();
  };
  const encender = (porCorriente, color) => {
    if (porCorriente) contacto(color);
    if (color && color !== S.terceroCorriente) { S.terceroCorriente = color; build(); if (S.enc) frame(performance.now(), true); }
    if (S.enc) return;
    clearTimeout(S.guard);
    if (porCorriente) { clearTimeout(S.demora); S.demora = setTimeout(prender, 190); return; }
    prender();
  };

  // entrada: plancha entrando en registro
  const registerBlocks = () => {
    if (!stage) return;
    const blocks = Array.from(stage.querySelectorAll('[data-eq-reg]'));
    const settle = () => blocks.forEach((b) => { b.style.clipPath = 'none'; b.style.transform = 'none'; });
    if (lento || yaVisto('club')) { settle(); return; }
    blocks.forEach((b) => { b.style.transform = 'translateY(10px)'; });
    const run = () => {
      blocks.forEach((b, i) => {
        S.regT.push(setTimeout(() => {
          b.style.transition = 'clip-path .42s cubic-bezier(.65,0,.35,1),transform .42s cubic-bezier(.65,0,.35,1)';
          b.style.clipPath = 'inset(0)'; b.style.transform = 'translateY(0)';
        }, i * 110));
      });
      S.regT.push(setTimeout(settle, 200 + blocks.length * 110 + 500));
    };
    const io = new IntersectionObserver((es) => { if (es.some((e) => e.isIntersecting)) { io.disconnect(); run(); } }, { threshold: 0.15 });
    io.observe(stage);
    S.regT.push(setTimeout(() => { io.disconnect(); settle(); }, 4200));
  };

  // grano: corta el banding del negro sin leerse como ruido. El ruido se genera
  // una sola vez y queda de fondo: cero costo por cuadro.
  const grain = () => {
    const el = q('[data-ref="grain"]');
    if (!el) return;
    el.style.opacity = '0.15';
    if (el.__eq) return;
    const Sz = 180, c = document.createElement('canvas');
    c.width = Sz; c.height = Sz;
    const x = c.getContext('2d'), im = x.createImageData(Sz, Sz);
    for (let i = 0; i < im.data.length; i += 4) {
      const v = Math.random() < 0.5 ? 0 : 255;
      im.data[i] = im.data[i + 1] = im.data[i + 2] = v;
      im.data[i + 3] = Math.round(Math.random() * 40);
    }
    x.putImageData(im, 0, 0);
    el.style.backgroundImage = 'url(' + c.toDataURL() + ')';
    el.__eq = true;
  };

  const ctaIn = () => { S.hover = true; if (ctaDot) ctaDot.style.background = '#ec673d'; };
  const ctaOut = () => { S.hover = false; if (ctaDot) ctaDot.style.background = '#1f1e1f'; };
  if (cta) { cta.addEventListener('pointerenter', ctaIn); cta.addEventListener('pointerleave', ctaOut); }

  build();
  S.io = new IntersectionObserver((es) => { es.forEach((e) => { S.visible = e.isIntersecting; pump(); }); }, { rootMargin: '140px' });
  S.io.observe(sec);
  const onResize = () => { sizeField(); measure(); frame(performance.now(), true); };
  window.addEventListener('resize', onResize);
  const onCorriente = (e) => encender(true, (e && e.detail && e.detail.color) || null);
  window.addEventListener('eq:corriente', onCorriente);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(onResize);
  sizeField(); splitType(); measure(); grain(); frame(performance.now(), true); registerBlocks();
  // ya encendido en esta sesion: arranca prendido, sin esperar la corriente ni el destello
  if (yaVisto('club')) prender();

  return () => {
    if (S.io) S.io.disconnect();
    window.removeEventListener('resize', onResize);
    window.removeEventListener('eq:corriente', onCorriente);
    clearTimeout(S.guard); clearTimeout(S.demora); clearTimeout(S.moT);
    if (S.raf) cancelAnimationFrame(S.raf);
    S.regT.forEach(clearTimeout);
    if (S.mo) S.mo.disconnect();
    if (cta) { cta.removeEventListener('pointerenter', ctaIn); cta.removeEventListener('pointerleave', ctaOut); }
  };
});
